import { useContext } from "react";
import { ProjectContext } from "../context/projectContext";

const useProjectContext = () => {
  return useContext(ProjectContext);
};

export default useProjectContext;
